/**
 * The icons used on row actions. Inline SVG rather than an icon font or a library: three glyphs is
 * not worth a dependency, and an inline path inherits `currentColor` so a disabled or hovered button
 * colours its icon without a second rule.
 *
 * Every button using one carries an `aria-label` and a `title` — an icon on its own says nothing to a
 * screen reader, and nothing to anyone who has not met that icon before.
 */
export function EditIcon() {
  return (
    <svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
      <path d="M11.5 2.5a1.6 1.6 0 0 1 2.3 2.3L5.6 13 2.5 13.5l.5-3.1z" strokeLinejoin="round" />
    </svg>
  );
}

/**
 * A padlock standing open — a finished referral being unlocked. Open rather than shut on purpose: the
 * button is the way out of the lock, and a closed padlock on it would read as the thing that put the
 * row there rather than the thing that lifts it.
 */
export function UnlockIcon() {
  return (
    <svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
      <rect x="3" y="7.5" width="10" height="6.5" rx="1.2" />
      <path d="M5.5 7.5V5a2.5 2.5 0 0 1 5 0" strokeLinecap="round" />
    </svg>
  );
}

export function RemoveIcon() {
  return (
    <svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
      <path d="M2.5 4.5h11M6 4.5V3a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v1.5M4 4.5l.7 8.2a.8.8 0 0 0 .8.8h5a.8.8 0 0 0 .8-.8l.7-8.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
